import React from 'react';
import { db } from '../firebase';

export const MyContext = React.createContext();
export class MyProvider extends React.Component {
  state = {
    users: [],
    trips: [],
    penddingTrips: {},
    drivers: [],
    config: {
      commission: 20,
      stripe: 10,
      driver: 70
    },
    requstTrip: 0,
    cancelledTrip: 0,
    totalUser: 0,
    notVerifiedDrivers: {},
    activeDriverList: {},
    verifiedDrivers: {},
    totalDriver: 0,
    totalTrip: 0,
    completeTrip: 0,
    totalDistance: 0,
    notVerified: 0,
    totalEarning: 0,
    onGoing: 0,
    activeDriver: 0,
  }
  constructor(props) {
    super(props);
    const _this = this;
    db.getRecord("admin/config", function (config) {
      config = config.val();
      _this.setState({
        config
      })
    });
    db.getRecord("admin/withdrawRequest", data => {
      let withdrawRequest = [];
      let withdrawFunded = [];
      let withdrawRequestList = data.val();
      let count = 0;
      data.forEach(child => {
        let driver = child.val();
        if (child.key != 'lastUpdateDate') {
          driver.key = child.key;
          if (!withdrawRequestList.lastUpdateDate || withdrawRequestList.lastUpdateDate < driver.createdTimestamp) {
            count++;
          }
          if (driver.funded) {
            withdrawFunded.push(driver);
          } else {
            withdrawRequest.push(driver);
          }
        }
      });
      if (count != 0) {
        db.writeData("admin/withdrawRequest/lastUpdateDate", new Date().getTime(), false);
        db.writeData("admin/notifications", {
          title: `${count} new withdraw requests`,
          to: "/withdraw",
          createdTimestamp: new Date().getTime()
        }, true);
      }
      _this.setState({
        withdrawRequest,
        withdrawFunded
      })
    });
    db.getRecord("admin/notifications", function (data) {
      let notification = [];
      data.forEach(function (child) {
        let driver = child.val();
        driver.key = child.key;
        notification.push(driver);
      });
      _this.setState({
        notification
      })
    });
    db.getDriver("value", function (data) {
      let drivers = [];
      data.forEach(function (child) {
        let driver = child.val();
        driver.key = child.key;
        drivers.push(driver);
      });
      drivers = drivers.reverse();
      let notVerified, totalDriver, totalTrip, totalEarning, onGoing, activeDriver, totalDistance = 0;
      notVerified = totalDriver = totalTrip = totalEarning = onGoing = activeDriver = totalDistance = 0;
      let notVerifiedDrivers = [];
      let verifiedDrivers = [];
      let activeDriverList = [];
      drivers.map((item) => {
        totalDriver++;
        if (item.online && item.coordinate) {
          activeDriver++;
          activeDriverList.push(item);
        }
        if (item.tripData) {
          if (item.isOnTrip) onGoing++;
          totalTrip += item.tripData.totalTrip;
          totalEarning += Number(item.tripData.totalEarning);
          totalDistance += item.tripData.totalDistance;
        }
        if (item.verified != null && !item.verified) {
          notVerifiedDrivers.push(item);
          notVerified++;
        } else {
          verifiedDrivers.push(item);
        }
      });
      _this.setState({
        drivers,
        notVerifiedDrivers,
        activeDriverList,
        verifiedDrivers,
        totalDriver,
        totalTrip,
        totalDistance,
        notVerified,
        totalEarning,
        activeDriver,
        driverList: data.val()
      });
    });
    db.getUser("value", function (data) {
      let users = [];
      data.forEach(function (child) {
        let user = child.val();
        user.key = child.key;
        users.push(user);
      });
      users = users.reverse();
      let requstTrip = 0, cancelledTrip = 0, totalUser = 0, onGoing = 0, completeTrip = 0;
      let trips = [];
      Object.keys(users).map(key => {
        totalUser++;
        if (users[key].history) {
          let history = users[key].history;
          Object.keys(users[key].history).map(hkey => {
            if (history[hkey].isTripOver) {
              completeTrip++;
            } else if (!history[hkey].status) {
              cancelledTrip++;
            } else if (history[hkey].isTripStarted) {
              onGoing++
            } else if (!history[hkey].isTripStarted) {
              requstTrip++;
            }
            history[hkey].key = hkey;
            trips.push(history[hkey]);
          })
        }
      })
      _this.setState({
        users,
        requstTrip,
        cancelledTrip,
        totalUser,
        trips,
        completeTrip,
        onGoing
      })
    });
  }
  custom_sort(a, b) {
    if (a.createdTimestamp) {
      return b.createdTimestamp - a.createdTimestamp;
    }
    return b.lastUpdateDate - a.lastUpdateDate;
  }
  render() {
    return (
      <MyContext.Provider value={this.state}>
        {this.props.children}
      </MyContext.Provider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/context/index.js